<template>
    <div v-if="showBackgroundStyle" class="custom-upload">
        <template v-if="$$FormData.background_style === 'color'">
            <el-button type="text" @click="backgroundColor = ''">重置</el-button>
            <el-color-picker v-model="backgroundColor" show-alpha :predefine="predefineColors" />
        </template>
        <template v-else-if="$$FormData.background_style === 'swiper'"></template>
        <template v-else>
            <image-selector v-model="backgroundImage" />
            <p v-if="!backgroundImage" class="tip-error">请上传背景图片</p>
        </template>
    </div>
</template>

<script>
export default {
    name: 'pageBackgroundImageStyle',
    data() {
        return {
            backgroundImage: '',
            backgroundColor: '',
            predefineColors: [
                '#ff4500',
                '#ff8c00',
                '#ffd700',
                '#90ee90',
                '#00ced1',
                '#1e90ff',
                '#c71585',
                'rgba(255, 69, 0, 0.68)',
                'rgb(255, 120, 0)',
                'hsv(51, 100, 98)',
                'hsva(120, 40, 94, 0.5)',
                'hsl(181, 100%, 37%)',
                'hsla(209, 100%, 56%, 0.73)',
                '#c7158577'
            ]
        }
    },
    watch: {
        backgroundImage: {
            deep: true,
            immediate: false,
            handler(newVal) {
                this.$$FormData.page_background_image = newVal.src || ''
            }
        },
        backgroundColor: {
            deep: true,
            immediate: false,
            handler(newVal) {
                this.$$FormData.page_background_color = newVal
            }
        }
    },
    computed: {
        /**
         * 是否显示组件
         * @returns {boolean}
         */
        showBackgroundStyle() {
            return this.$$FormData.show_background_style
        }
    },
    mounted() {
        if (this.$$FormData.background_style === 'color') {
            this.backgroundColor = this.$$FormData.page_background_color
        } else {
            this.backgroundImage = {
                src: this.$$FormData.page_background_image
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.custom-upload {
    display: flex;
    align-items: flex-end;
    margin-top: 12px;
    line-height: normal;
    .upload-box,
    .custom-img {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 60px;
        overflow: hidden;
        color: #155bd4;
        font-size: 20px;
        border: 1px solid #e5e5e5;
        background-color: #f2f4f6;
        cursor: pointer;
        .label-box {
            font-size: 12px;
            margin: 0;
            margin-top: 4px;
        }
    }
    .tip-error {
        margin-top: 5px;
        font-size: 12px;
        color: #d40000;
    }
    .tip-upload {
        color: #969799;
        margin-left: 10px;
        font-size: 12px;
    }
    .custom-img {
        position: relative;
        cursor: auto;
        .img-upload {
            width: 100%;
            height: 100%;
        }
        .change-btn {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 20px;
            line-height: 20px;
            text-align: center;
            font-size: 12px;
            color: #ffffff;
            background-color: rgba(0, 0, 0, 0.5);
            cursor: pointer;
        }
    }
}
</style>
